module.exports = __webpack_public_path__ + "img/BecomeIns-5.a43affb4.svg";